// @flow

import type {TreeStructure} from '../typedef';

export const getTreeDepth = (data: TreeStructure): number => {
    // eslint-disable-next-line @pb/flowtype/no-use-before-define
    const getMathValue = treeNodes => Math.max(...treeNodes.map(checkItem));

    const checkItem = ({children}) => {
        return 1 + (children ? getMathValue(children) : 0);
    };

    return getMathValue(data);
};
